import { loadClassicScript } from "./loadScript.js";

export async function getRecaptchaToken(action) {
  const siteKey = window.RECAPTCHA_SITE_KEY || import.meta.env.VITE_RECAPTCHA_SITE_KEY;
  if (!siteKey) return null;

  try {
    if (!window.grecaptcha) {
      await loadClassicScript(`https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`, {
        id: "stemeit-recaptcha"
      });
    }
    return await new Promise((resolve) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(siteKey, { action }).then(resolve).catch(() => resolve(null));
      });
    });
  } catch {
    return null;
  }
}
